module.exports = __webpack_public_path__ + "static/media/WUSD.4a4e17c0.svg";